module.exports = __webpack_public_path__ + "static/media/print_02_C.7a49a128.png";